import { authService } from '../services/authService';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

export const use2FA = () => {
  const queryClient = useQueryClient();

  // Fetch 2FA status
  const { data: status, isLoading: isLoadingStatus } = useQuery({
    queryKey: ['2fa-status'],
    queryFn: () => authService.get2FAStatus(),
  });

  // Setup 2FA (generate QR code)
  const setupMutation = useMutation({
    mutationFn: () => authService.setup2FA(),
  });

  // Enable 2FA
  const enableMutation = useMutation({
    mutationFn: (token: string) => authService.enable2FA(token),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['2fa-status'] });
    },
  });

  // Disable 2FA
  const disableMutation = useMutation({
    mutationFn: (token: string) => authService.disable2FA(token),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['2fa-status'] });
    },
  });

  // Verify 2FA code
  const verifyMutation = useMutation({
    mutationFn: (token: string) => authService.verify2FA(token),
  });

  // Verify recovery code
  const verifyRecoveryMutation = useMutation({
    mutationFn: (recoveryCode: string) => authService.verifyRecoveryCode(recoveryCode),
  });

  return {
    status,
    isLoadingStatus,
    setup: setupMutation.mutateAsync,
    enable: enableMutation.mutateAsync,
    disable: disableMutation.mutateAsync,
    verify: verifyMutation.mutateAsync,
    verifyRecovery: verifyRecoveryMutation.mutateAsync,
    isSettingUp: setupMutation.isPending,
    isEnabling: enableMutation.isPending,
    isDisabling: disableMutation.isPending,
    isVerifying: verifyMutation.isPending,
    setupData: setupMutation.data,
    setupError: setupMutation.error,
    enableError: enableMutation.error,
    disableError: disableMutation.error,
    verifyError: verifyMutation.isPending,
  };
};
